import styled from '@emotion/styled'
import { useContext } from 'react'
import { Flex } from 'rebass'

import { GameDifficultyContext } from '../utils/GameModeContext'
import { isNovice } from '../utils/utility'
import ScoreCard from './ScoreCard'

const HeaderContainer = styled(Flex)`
  border: 2px solid ${({ theme }) => theme.colors.components.header.border};
  border-radius: 10px;
  padding: 15px 15px;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  min-width: 320px;
  @media (max-width: 1366px) {
    min-width: 290px;
  }
`

const Image = styled('img')`
  height: 85px;
`

const Header = ({ score }) => {
  const { difficulty } = useContext(GameDifficultyContext)

  return (
    <HeaderContainer>
      <Image
        src={isNovice(difficulty) ? './images/logo.svg' : './images/logo-bonus.svg'}
        alt="logo"
      />
      <ScoreCard score={score} />
    </HeaderContainer>
  )
}

export default Header
